import React, { useState, useRef } from "react";
import opentype from "opentype.js";


const fontGlyphCache = {};


export default function FontGlyphDialog({
    fontUrl,
    defaultString = "",
    onGlyphSelected,
    onScrollOpen
}) {

const [glyphs, setGlyphs] = useState([]);
const [open, setOpen] = useState(false);

const gridRef = useRef(null);
const currentFontRef = useRef(null);



const loadGlyphs = () => {


    // Different font - reset scroll
    if(currentFontRef.current !== fontUrl)
    {
        if(gridRef.current)
        {
            gridRef.current.scrollTop = 0;
        }

        currentFontRef.current = fontUrl;
    }



    // Use cache
    if(fontGlyphCache[fontUrl])
    {
        setGlyphs(fontGlyphCache[fontUrl]);
        setOpen(true);
        if(onScrollOpen)
        {
            onScrollOpen(true);
        }
        return;
    }



    opentype.load(fontUrl, (err, font) => {

        if(err)
        {
            console.error(
                "Font load error:",
                err
            );

            return;
        }



        const cmap =
            font.tables.cmap.glyphIndexMap;



        const result =
            Object.keys(cmap)
            .map(code => {

                const unicode = Number(code);

                const char =
                    String.fromCodePoint(unicode);



                const path =
                    font.getPath(
                        char,
                        0,
                        100,
                        100
                    );



                const bbox =
                    path.getBoundingBox();



                const padding = 10;



                return {

                    unicode,


                    hex:
                    "U+" +
                    unicode
                    .toString(16)
                    .toUpperCase()
                    .padStart(4,"0"),


                    char,


                    glyphId:
                    cmap[unicode],


                    svgPath:
                    path.toPathData(2),


                    viewBox:
                    [
                        bbox.x1-padding,
                        bbox.y1-padding,
                        (bbox.x2-bbox.x1)+padding*2,
                        (bbox.y2-bbox.y1)+padding*2
                    ].join(" ")

                };

            })
            .filter(
                g => g.glyphId !== 0
            );



        // Save cache
        fontGlyphCache[fontUrl] = result;


        setGlyphs(result);
        setOpen(true);
        if(onScrollOpen)
        {
            onScrollOpen(true);
        }

    });

};

const selectGlyph = (glyph) => {

    // hide only, do not destroy
    setOpen(false);
    if(onScrollOpen)
    {
        onScrollOpen(false);
    }



    if(onGlyphSelected)
    {
        onGlyphSelected(
            defaultString + glyph.char
        );
    }

};




return (

<>

<button onClick={loadGlyphs}>
    Show Font Glyphs
</button>



<div
    style={{
        ...styles.overlay,
        display: open ? "flex" : "none"
    }}
>


    <div style={styles.dialog}>


        <div style={styles.header}>


            <h3>
                Font Glyphs ({glyphs.length})
            </h3>


            <button
                onClick={() => {    
                        if(onScrollOpen)
                        {
                            onScrollOpen(false);
                        }
                        setOpen(false)}}
            >
                X
            </button>


        </div>



        <div
            id="scroll-list"
            ref={gridRef}
            style={styles.grid}
        >


        {
            glyphs.map((g,i)=>(

                <div
                    key={i}
                    style={styles.cell}
                    onClick={() => selectGlyph(g)}
                >


                    <svg
                        width="80"
                        height="80"
                        viewBox={g.viewBox}
                        preserveAspectRatio="xMidYMid meet"
                    >

                        <path
                            d={g.svgPath}
                            fill="black"
                        />

                    </svg>



                    <div>
                        {g.hex}
                    </div>


                    <div>
                        Glyph {g.glyphId}
                    </div>


                </div>

            ))
        }


        </div>


    </div>
</div>
</>
);

}



const styles = {


overlay: {

    position:"fixed",
    inset:0,
    background:"rgba(0,0,0,.5)",
    alignItems:"center",
    justifyContent:"center",
    zIndex:9999

},



dialog: {

    background:"white",
    width:"80%",
    height:"80%",
    borderRadius:"8px",
    padding:"20px",
    overflow:"hidden"

},



header: {

    display:"flex",
    justifyContent:"space-between",
    alignItems:"center",
    height:"40px"

},



grid: {

    height:"calc(100% - 50px)",
    overflowY:"auto",
    overscrollBehaviorY: "contain",
    display:"grid",

    gridTemplateColumns:
    "repeat(auto-fill, minmax(120px, 1fr))",

    gap:"10px"

},



cell: {

    border:"1px solid #ccc",
    padding:"10px",
    textAlign:"center",
    cursor:"pointer"

}


};

